<template>
    <b-card header="Manage Carriers / Blocks"
        header-bg-variant="info"
        header-text-variant="white"
    >
        <loading-card v-show="loading"></loading-card>

        <div class="d-flex mb-3 justify-content-between">
            <b-btn href="/business/users/create" class="" variant="info">Create Office User</b-btn>
            <b-btn href="/business/carriers/create" class="" variant="info">Add New Carrier / Block</b-btn>
        </div>

        <div v-if="! loading" class="table-responsive">
            <b-table bordered striped hover show-empty
                :items="carriers"
                :fields="fields"
                :per-page="0"
                sort-by="name"
            >
                <template v-slot:cell(actions)="{ item }">
                    <b-btn :href="`/business/carriers/${item.id}`"><i class="fa fa-edit" /></b-btn>
                </template>
            </b-table>
        </div>

    </b-card>
</template>

<script>
    import FormatsDates from '../../mixins/FormatsDates';
    export default {
        mixins: [ FormatsDates ],
        props: {
        },

        data() {
            return {
                carriers: [],
                loading: false,
                fields: [
                    { key: 'name', sortable: true },
                    { key: 'initials', sortable: true },
                    { key: 'created_at', label: 'Date Added', sortable: true, formatter: x => this.formatDateFromUTC(x) },
                    { key: 'actions', sortable: false }
                ],
            }
        },

        methods: {
            fetch() {
                this.loading = true;
                axios.get('/business/carriers?json=1')
                    .then( ({ data }) => {
                        this.carriers = data;
                    })
                    .catch(e => {})
                    .finally(() => {
                        this.loading = false;
                    });
            },
        },

        mounted() {
            this.loading = true;
            this.fetch();
        },
    }
</script>

<style>
</style>